import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { publicApi } from '../utils/api';

const ResourcePage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const response = await publicApi.getSeoPageBySlug(slug);
        setPage(response.data || null);
      } catch {
        setPage(null);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [slug]);

  if (loading) {
    return <div className="min-h-screen pt-24 page-bg-shell page-bg-devices"><section className="container mx-auto px-6 py-16"><div className="terminal-grid p-6"><p style={{ color: 'var(--text-secondary)' }}>Loading resource...</p></div></section></div>;
  }

  if (!page) {
    return <div className="min-h-screen pt-24 page-bg-shell page-bg-devices"><section className="container mx-auto px-6 py-16"><div className="terminal-grid p-6"><p style={{ color: 'var(--text-secondary)' }}>Resource not found.</p></div></section></div>;
  }

  return (
    <div className="min-h-screen pt-24 page-bg-shell page-bg-devices" data-testid="resource-page">
      <section className="container mx-auto px-6 py-16">
      <div className="max-w-4xl mx-auto">
        <p className="text-xs uppercase font-mono mb-3" style={{ color: 'var(--text-muted)' }}>{page.page_type || 'resource'}</p>
        <h1 className="text-4xl font-black mb-4" style={{ fontFamily: 'Unbounded, sans-serif', color: 'var(--text-primary)' }}>{page.title}</h1>
        {page.target_keyword && <p className="text-sm mb-2" style={{ color: 'var(--accent-primary)' }}>Target keyword: {page.target_keyword}</p>}
        {page.excerpt && <p className="text-lg mb-8" style={{ color: 'var(--text-secondary)' }}>{page.excerpt}</p>}
        <div className="terminal-grid p-8 whitespace-pre-wrap leading-7" style={{ color: 'var(--text-secondary)' }}>
          {page.body || 'No body content has been published yet.'}
        </div>
      </div>
      </section>
    </div>
  );
};

export default ResourcePage;
